import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function Hero() {
  const handleScrollToPricing = () => {
    const pricingSection = document.getElementById('pricing');
    if (pricingSection) {
      pricingSection.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  };
  return <section className="relative w-full min-h-screen flex items-center justify-center px-4 py-20 bg-gradient-to-b from-cream to-beige" data-id="element-102">
      <div className="max-w-4xl mx-auto text-center" data-id="element-103">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="text-4xl md:text-6xl lg:text-7xl font-serif font-bold text-charcoal mb-8 leading-tight" data-id="element-104">
          Stop Fighting Biology: The 4-Stage 'Crib Transfer' That Actually
          Sticks
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="prose prose-lg md:prose-xl max-w-3xl mx-auto mb-12 text-charcoal/80" data-id="element-105">
          <p className="text-left md:text-center leading-relaxed mb-4" data-id="element-106">
            It's 2:14 AM.
          </p>
          <p className="text-left md:text-center leading-relaxed mb-4" data-id="element-107">
            Your back aches. Your eyes are burning. You've been rocking,
            bouncing, and shushing for forty-five minutes. Your baby is finally,{' '}
            <em data-id="element-108">finally</em> limp in your arms.
          </p>
          <p className="text-left md:text-center leading-relaxed mb-4" data-id="element-109">
            Exhale.
          </p>
          <p className="text-left md:text-center leading-relaxed mb-4" data-id="element-110">
            You lean over the crib, moving at the speed of a diamond thief. You
            lower them down with bated breath.
          </p>
          <p className="text-left md:text-center leading-relaxed mb-4" data-id="element-111">
            Contact.
          </p>
          <p className="text-left md:text-center leading-relaxed mb-4" data-id="element-112">
            One second passes. Two. You start to pull away—and then it happens.
            The arms fly out. The eyes pop open. The scream begins.
          </p>
          <p className="text-left md:text-center leading-relaxed font-semibold text-xl" data-id="element-113">
            The Transfer failed. Again.
          </p>
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="text-xl md:text-2xl text-charcoal/70 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-114">
          You aren't doing anything wrong. You aren't a "bad mom" and your baby
          isn't "broken." You're just fighting 200,000 years of human biology…
          and biology is winning.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.8
      }} data-id="element-115">
          <CTAButton size="large" onClick={handleScrollToPricing} data-id="element-116">
            Start the Sleep Reset
          </CTAButton>
        </motion.div>
      </div>
    </section>;
}